/* eslint-disable import/no-named-as-default */
import React from "react";
import PropTypes from "prop-types";
import { Provider } from "react-redux";
import store from "../../store";
import DashboardModal from "./DashboardModal";

const ModalProvider = (props) => {
  const { pendingReview, finishJobPost, finishJobPostId } = props;

  return (
    <Provider store={store}>
      <DashboardModal
        pendingReview={pendingReview}
        finishJobPost={finishJobPost}
        finishJobPostId={finishJobPostId}
      />
    </Provider>
  );
};

ModalProvider.propTypes = {
  pendingReview: PropTypes.shape({
    reviewId: PropTypes.number,
    jobId: PropTypes.number,
    jobTitle: PropTypes.string,
    agentName: PropTypes.string,
    agentCompany: PropTypes.string,
  }),
  finishJobPost: PropTypes.bool,
  finishJobPostId: PropTypes.number,
};

ModalProvider.defaultProps = {
  pendingReview: PropTypes.isNull,
  finishJobPost: PropTypes.isNull,
  finishJobPostId: PropTypes.isNull,
};

export default ModalProvider;
